module.exports = __webpack_public_path__ + "img/hat1.f2248c10.svg";